var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { ApplicationPropertiesService } from '@synisys/idm-application-properties-service-client-js';
import { HttpClient } from '@angular/common/http';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { BasePageService, PageStructureDto, } from '@synisys/idm-page-service-client-js';
import { Observable } from 'rxjs/Observable';
var JsonBasedPageService = /** @class */ (function (_super) {
    __extends(JsonBasedPageService, _super);
    function JsonBasedPageService(http, applicationPropertiesService) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.applicationPropertiesService = applicationPropertiesService;
        _this.kbJSON = new ReplaySubject(1);
        _this.propsJSON = new ReplaySubject(1);
        _this.kbJSONKey = 'dynamic-forms-kb-json-path';
        _this.propsJSONKey = 'dynamic-forms-properties-json-path';
        _this.init();
        return _this;
    }
    JsonBasedPageService.prototype.getPageStructure = function (pageId, pageName) {
        var _this = this;
        return Observable.combineLatest(this.kbJSON, this.propsJSON)
            .first()
            .map(function (data) {
            var kbJson = {};
            var propJson = {};
            kbJson[pageName] = data[0][pageName];
            propJson[pageName] = data[1][pageName];
            return _this.createPageModel(kbJson, propJson);
        });
    };
    JsonBasedPageService.prototype.addPage = function (page) {
        throw Error('Not Implemented Yet');
    };
    JsonBasedPageService.prototype.deletePage = function (pageId) {
        throw Error('Not Implemented Yet');
    };
    JsonBasedPageService.prototype.getPage = function (pageId) {
        throw Error('Not Implemented Yet');
    };
    JsonBasedPageService.prototype.updatePage = function (page) {
        throw Error('Not Implemented Yet');
    };
    JsonBasedPageService.prototype.updatePageStructure = function (pageId, pageStructure) {
        throw Error('Not Implemented Yet');
    };
    JsonBasedPageService.prototype.getPageHierarchy = function (pageId) {
        throw Error('Not Implemented Yet');
    };
    JsonBasedPageService.prototype.getPagePath = function (pageId) {
        throw Error('Not Implemented Yet');
    };
    JsonBasedPageService.prototype.getAllPages = function () {
        throw Error('Not Implemented Yet');
    };
    JsonBasedPageService.prototype.updatePages = function (pages) {
        throw Error('Not Implemented Yet');
    };
    JsonBasedPageService.prototype.init = function () {
        var _this = this;
        this.applicationPropertiesService
            .getProperty(this.kbJSONKey)
            .then(function (path) {
            return _this.http.get(path).subscribe(function (data) { return _this.kbJSON.next(data); }, function (error) { return console.error(error); });
        });
        this.applicationPropertiesService
            .getProperty(this.propsJSONKey)
            .then(function (path) {
            return _this.http.get(path).subscribe(function (data) { return _this.propsJSON.next(data); }, function (error) { return console.error(error); });
        });
    };
    JsonBasedPageService.prototype.createPageModel = function (kbJSON, propsJSON) {
        var obj = JSON.stringify({
            layout: JSON.stringify(kbJSON),
            property: JSON.stringify(propsJSON),
        });
        return new PageStructureDto(obj);
    };
    JsonBasedPageService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [HttpClient,
            ApplicationPropertiesService])
    ], JsonBasedPageService);
    return JsonBasedPageService;
}(BasePageService));
export { JsonBasedPageService };
//# sourceMappingURL=json-based-page.service.js.map